import { Component } from '@angular/core';

@Component({
  selector: 'cap-bsg-actionbar',
  template: `
    <div id="actionpane" class="p-2" style="display: flex; flex-direction: row; justify-content: flex-end">
      <ng-content></ng-content>
    </div>
  `
})
export class CapActionbarComponent {

}
